










































import { Vue, Component, Prop } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import { fetchAdd } from './fetchAdd';
const { AgGridVue } = require('ag-grid-vue');

import { DataApi, DevicesApi } from './models/Add.model';

@Component({
  components: {
    AgGridVue,
    FormFieldsContainer,
  },
})
export default class AddEquipos extends Vue {
  @Prop({ required: true, default: [] }) data: DataApi;
  @Prop({ required: true, default: [] }) deviceList!: DevicesApi[];
  @Prop({ required: true, default: true }) dialog!: boolean;

  quickSearch: string = '';
  orderList: DevicesApi[] = [];
  selectedRows: DevicesApi[] = [];

  timeout: { timeout: number } = { timeout: 3000 };

  async handleGridReady(event: GridReadyEvent) {
    this.orderList = await this.getDevices(this.data);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.orderList);
    this.gridApi.setDomLayout('autoHeight');
  }

  ClosedModal(): void {
    this.$emit('closedModalDevices');
  }

  save(): void {
    const savedDevices = this.selectedRows;
    this.$emit('selected', savedDevices);
    this.$emit('closedModalDevices');
  }

  async getDevices(data: DataApi): Promise<DevicesApi[]> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchAdd({
      endpoint: 'get_devices',
      body: {
        device_list: this.deviceList,
        ...data,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1 || MENSAJE_RESPUESTA) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        return [...LISTA];
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
          return [];
        }
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { ...self.timeout }
        );
        return [];
      })
      .finally(() => self.loadingService.hideLoading());
  }

  onModelUpdated(): void {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(): void {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  // Globales
  tabModel: string = 'tab-3';
  muestraBarraBotones: boolean = false;
  registrosAsociar: any = [];
  rowsPerPageItems: any = [];
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  showTabPerfiles: boolean = true;
  showTabRoles: boolean = true;
  loadingService = new LoadingService();
  paramsExportar: any; //Parametros para Exportar
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  nombreModulo: string = '';

  // Controller
  readonly $snotify: Snotify = null;
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';

  // Grilla
  gridApi: GridApi = null;
  columnApi: ColumnApi = null;
  columnDefs: ColDef[] = [];
  agGridUtil: AgGridUtil = null;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      localeText: {
        noRowsToShow: 'No hay equipos disponibles para mostrar',
      },
      pagination: true,
      paginationPageSize: 10, //Solución Paginación
      cacheBlockSize: 10, //Solución Paginación
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      onGridSizeChanged: event => event.api.sizeColumnsToFit(),
    };
  }

  private colsGrid(): ColDef[] {
    const cols = [
      { id: 'serienumero', field: 'Serie Número' },
      { id: 'tipoeqname', field: 'Equipo' },
      { id: 'simserienumero', field: 'SIM' },
      { id: 'simestado', field: 'Estado SIM' },
      { id: 'telconame', field: 'Telco' },
    ];
    const columns: ColDef[] = cols.map(col => {
      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: true,
        width: 200,
        minWidth: 200,
      };
    });

    columns.unshift({
      minWidth: 70,
      width: 75,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
    });

    return columns;
  }
}
